import Guid from 'es/core/types/Guid';

export const MAX_RESULTS_PER_PROVIDER = 3;

export interface IUniversalSearchCriteria {
    id: Guid | null;
    text: string | null;
}